import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidePage from "@/pages/guide/page";
import SafetyPage from "@/pages/safety/page";
import DatabasePage from "@/pages/database/page";
import ComparisonPage from "@/pages/comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <GuidePage />,
  },
  {
    path: "/superbuy-spreadsheet-safety",
    element: <SafetyPage />,
  },
  {
    path: "/superbuy-spreadsheet-database",
    element: <DatabasePage />,
  },
  {
    path: "/superbuy-spreadsheet-comparison",
    element: <ComparisonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;